// src/pages/GoogleCallbackPage.jsx
// Handles mobile OAuth redirect callback only.
// Desktop uses GSI popup which doesn't need this page.

import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import BrandLoadingScreen from '../components/BrandLoadingScreen';

export default function GoogleCallbackPage() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const idToken = params.get('id_token');
    const returnPath = sessionStorage.getItem('google_oauth_return') || '/dashboard';

    if (!idToken) {
      navigate('/login', { replace: true });
      return;
    }

    sessionStorage.removeItem('google_oauth_state');
    sessionStorage.removeItem('google_oauth_return');
    window.history.replaceState({}, document.title, window.location.pathname);

    axios.post(`${process.env.REACT_APP_API_URL}/api/auth/google`, { token: idToken })
      .then(res => {
        if (res.data.status === 'success') {
          login(res.data.user, res.data.token);
          setTimeout(() => navigate(returnPath, { replace: true }), 100);
        } else {
          navigate('/login?error=google_failed', { replace: true });
        }
      })
      .catch(() => navigate('/login?error=google_failed', { replace: true }));
  }, []);

  return <BrandLoadingScreen message="Signing you in with Google…" />;
}